import type { JSX } from 'react'
import { Toaster } from '@ttab/elephant-ui'
import { useTheme } from '@/hooks'

/**
 * Toaster that follows the app theme. Without it, sonner falls back to the OS theme.
 */
export const ThemedToaster = (): JSX.Element => {
  const { theme } = useTheme()

  return <Toaster theme={theme} />
}
